var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import cs from '../_util/classNames';
import { ConfigConsumer } from '../ConfigProvider';
var CarouselIndicator = /** @class */ (function (_super) {
    __extends(CarouselIndicator, _super);
    function CarouselIndicator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderIndicator = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls;
            var _c = _this.props, _d = _c.type, type = _d === void 0 ? 'line' : _d, _e = _c.count, count = _e === void 0 ? 2 : _e, _f = _c.activeIndex, activeIndex = _f === void 0 ? 0 : _f, _g = _c.position, position = _g === void 0 ? 'bottom' : _g, className = _c.className, _h = _c.trigger, trigger = _h === void 0 ? 'click' : _h;
            var prefixCls = getPrefixCls('carousel-indicator');
            var itemClass = cs(prefixCls + "-item", (_b = {},
                _b[prefixCls + "-item-dot"] = type === 'dot',
                _b));
            var ulClass = cs(prefixCls, prefixCls + "-" + position, className);
            var indicatorContent = [];
            for (var i = 0; i < count; i++) {
                var item = void 0;
                if (i === activeIndex) {
                    item = (React.createElement("li", { key: i, "data-index": i, className: itemClass + " " + prefixCls + "-item-active" },
                        React.createElement("button", { "data-index": i })));
                }
                else {
                    item = (React.createElement("li", { key: i, "data-index": i, className: itemClass },
                        React.createElement("button", { "data-index": i })));
                }
                indicatorContent.push(item);
            }
            return trigger === 'click' ? (React.createElement("ul", { className: ulClass, onClick: _this.props.onSelectIndex }, indicatorContent)) : (React.createElement("ul", { className: ulClass, onMouseEnter: _this.props.onSelectIndex }, indicatorContent));
        };
        return _this;
    }
    CarouselIndicator.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderIndicator);
    };
    return CarouselIndicator;
}(Component));
export default CarouselIndicator;
